import { render, staticRenderFns } from "./InvoiceListComponent.vue?vue&type=template&id=425f8da2&"
import script from "./InvoiceListComponent.vue?vue&type=script&lang=js&"
export * from "./InvoiceListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports